import { Inline, Text, vars } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { CheckCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import useGetPersonalAndCabinBaggageInfo from './hooks/useGetPersonalAndCabinBaggageInfo';
import CabinBaggageFeature, { iconStyles } from './CabinBaggageFeature';

const featureTextStyles = css`
  width: -webkit-fill-available; /* stylelint-disable */
`;

interface PersonalItemAndCabinBaggageIncludedFeatureProps {
  isPersonalItemIncluded: boolean;
  cabinBaggageTripSummary: CabinBaggageTripSummary;
}

const PersonalItemAndCabinBaggageIncludedFeature = ({
  isPersonalItemIncluded,
  cabinBaggageTripSummary,
}: PersonalItemAndCabinBaggageIncludedFeatureProps) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { isIncluded, personalAndCabinText } = useGetPersonalAndCabinBaggageInfo(
    isPersonalItemIncluded,
    cabinBaggageTripSummary,
  );
  const personalAndCabinBaggageShowType = String(
    p('BrandedFares.PersonalAndCabinBaggage.ShowType'),
  ).toUpperCase();
  const personalAndCabinBaggageDefaultShowType = 'SEPARATE';
  const personalAndCabinBaggageShowTypePair = 'PAIR';
  if (personalAndCabinBaggageShowType === personalAndCabinBaggageDefaultShowType) {
    const personalItemText =
      isPersonalItemIncluded && t('BrandedFares.PersonalBaggageIncluded.Text');
    const cabinBaggageFeature = (
      <CabinBaggageFeature cabinBaggageTripSummary={cabinBaggageTripSummary} />
    );
    return (
      <>
        {isPersonalItemIncluded && (
          <Inline as="li" noWrap role="listitem" spacing={8}>
            <CheckCircle
              className={iconStyles}
              color={vars.colors.signal.positive.foreground}
              size={20}
              weight="fill"
            />
            <Text as="p" className={featureTextStyles}>
              {personalItemText}
            </Text>
          </Inline>
        )}
        {cabinBaggageFeature}
      </>
    );
  }
  if (personalAndCabinBaggageShowType === personalAndCabinBaggageShowTypePair) {
    return (
      <>
        {isIncluded && (
          <Inline as="li" noWrap role="listitem" spacing={8}>
            <CheckCircle
              className={iconStyles}
              color={vars.colors.signal.positive.foreground}
              size={20}
              weight="fill"
            />
            <Text as="p" className={featureTextStyles}>
              {personalAndCabinText}
            </Text>
          </Inline>
        )}
      </>
    );
  }
  return null;
};

export default PersonalItemAndCabinBaggageIncludedFeature;
